function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

// Check if goibibo native apps are installed in user's device
// https://web.dev/get-installed-related-apps/#tell-your-android-app-about-your-website
var isRelatedAppInstalled = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(debug) {
    var installed, relatedApps;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            installed = false;
            _context.prev = 1;
            _context.next = 4;
            return navigator.getInstalledRelatedApps();

          case 4:
            relatedApps = _context.sent;
            if (debug) console.log('isRelatedAppInstalled', relatedApps);
            relatedApps.forEach(function (app) {
              if (app.id) installed = true;
            });
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            if (debug) console.error('isRelatedAppInstalled', _context.t0);
            return _context.abrupt("return", false);

          case 13:
            return _context.abrupt("return", installed);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function isRelatedAppInstalled(_x) {
    return _ref.apply(this, arguments);
  };
}(); // Detect if launched app is from browser or pwa installed bookmark


var isPwaLaunch = function isPwaLaunch() {
  return 'standalone' in window.navigator || window.matchMedia('(display-mode: standalone)').matches;
};

export { isPwaLaunch, isRelatedAppInstalled };
